<template>
  <div class="page-report">
    <div class="row mb-2 pe-4">
      <div class="col-lg-12 col-md-12 col-12 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-3">MEGAPOS DATA</h3>
        </div>
      </div>
    </div>
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto mt-4">
            <div class="row">
              <h2> Collection By Branch </h2>
            </div>
            <FormSearch
              :searchParameter="form"
              :onChangeSearchParameter="onChangeSearchParameter"
              :selectAllBranch="false"
              :hidePhysicalBranchFilter="false"
              :onlySelectMonth="false"
              @reload-data="fetchData"
              @export="exportFile"
            ></FormSearch>
            <div
              class="row mt-4"
              style="min-height: 1120px"
              v-if="isLoadDone"
              v-show="isLoadDoneDataTable"
            >
              <div class="col-12">
                <div>
                  <div class="px-0 pb-2">
                    <div class="d-flex justify-content-end align-items-center mb-3">
                      <label class="global-search mb-0">Search:
                        <input
                          type="search"
                          v-model="searchKeyword"
                          @input="onKeywordSearch"
                        />
                      </label>
                    </div>
                    <div class="p-0 custom-table">
                      <table
                        class="table align-items-center mb-0 dataTable"
                      >
                        <thead>
                          <tr>
                            <th class="text-center font-weight-bolder">
                              <div class="pt-4">Row No</div>
                            </th>
                            <template
                              v-for="(item, index) in headersData"
                              :key="index"
                            >
                              <th
                                class="text-center font-weight-bolder position-relative"
                              >
                                <div
                                  class="pt-4"
                                  style="position: unset;"
                                  :class="[
                                    !!item.hasSortBy
                                      ? 'wrapper-sortby pointer'
                                      : '',
                                    ESortDirectionSelect.idx == index + 1
                                      ? ESortDirectionSelect.direction ===
                                        ESortDirection.Desc
                                        ? 'sort-desc'
                                        : 'sort-asc'
                                      : '',
                                  ]"
                                  @click="
                                    handleChangeSortColumn(
                                      index + 1,
                                      item.field
                                    )
                                  "
                                  >{{ item.label }}</div
                                >
                              </th>
                            </template>
                            <th
                              class="text-center font-weight-bolder position-relative"
                              v-for="(paymentMethod, index) in paymentMethods"
                              :key="headersData.length + (index + 1)"
                            >
                              <div
                                class="pt-4"
                                style="position: unset;"
                                :class="[
                                  'wrapper-sortby pointer',
                                  ESortDirectionSelect.idx ==
                                  headersData.length + (index + 1)
                                    ? ESortDirectionSelect.direction ===
                                      ESortDirection.Desc
                                      ? 'sort-desc'
                                      : 'sort-asc'
                                    : '',
                                ]"
                                @click="
                                  handleChangeSortColumn(
                                    headersData.length + (index + 1),
                                    'payment_method',
                                    index
                                  )
                                "
                                >{{ paymentMethod }}</div
                              >
                            </th>
                          </tr>
                          <tr>
                            <th class="text-center font-weight-bolder">
                              <input
                                v-model="columnSearch[0]"
                                @input="searchColumn(0)"
                              />
                            </th>
                            <template
                              v-for="(item, index) in headersData"
                              :key="index"
                            >
                              <th class="text-center font-weight-bolder">
                                <input
                                  v-model="columnSearch[index + 1]"
                                  @input="searchColumn(index + 1)"
                                />
                              </th>
                            </template>
                            <th
                              class="text-center font-weight-bolder"
                              v-for="(paymentMethod, index) in paymentMethods"
                              :key="headersData.length + (index + 1)"
                            >
                              <input
                                v-model="
                                  columnSearch[headersData.length + (index + 1)]
                                "
                                @input="
                                  searchColumn(headersData.length + (index + 1))
                                "
                              />
                            </th>
                          </tr>
                        </thead>
                        <tbody v-if="paginatedRows.length">
                          <tr
                            v-for="(value, key) in paginatedRows"
                            :key="key"
                          >
                            <td class="text-right text-xss w-5">
                              {{ key + 1 + (pagination.current_page - 1) * limit }}
                            </td>
                            <td class="text-left text-xss w-10">
                              {{ value?.branch_name }}
                            </td>
                            <td class="text-right text-xss w-10">
                              {{ formatPrice(value?.sub_total) }}
                            </td>
                            <td class="text-right text-xss w-10">
                              {{ formatPrice(value?.discount) }}
                            </td>
                            <td class="text-right text-xss w-10">
                              {{ formatPrice(value?.gst) }}
                            </td>
                            <td class="text-right text-xss w-10">
                              {{ formatPrice(value?.service_charge) }}
                            </td>
                            <td class="text-right text-xss">
                              {{ formatPrice(value?.rounding) }}
                            </td>
                            <td class="text-right text-xss w-10">
                              {{ formatPrice(value?.total) }}
                            </td>
                            <td class="text-right text-xss">
                              {{ formatPrice(value.redemption) }}
                            </td>
                            <td class="text-right text-xss w-10">
                              {{ value?.bill_count }}
                            </td>
                            <td class="text-right text-xss w-10">
                              {{ formatPrice(value?.bill_avg) }}
                            </td>
                            <td
                              class="text-right text-xss w-10"
                              v-for="(
                                paymentMethod, index
                              ) in value.payment_methods"
                              :key="index"
                            >
                              {{ formatPrice(paymentMethod?.amount) }}
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else class="no-data">
                          <tr>
                            <td
                              :colspan="11 + paymentMethods.length"
                              class="text-left"
                            >
                              No matching records found
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr class="total-row">
                            <td class="text-right text-xss">TOTAL</td>
                            <td class="text-left text-xss"></td>
                            <td class="text-right text-xss">{{ formatPrice(totalSubTotal) }}</td>
                            <td class="text-right text-xss">{{ formatPrice(totalDiscount) }}</td>
                            <td class="text-right text-xss">{{ formatPrice(totalGst) }}</td>
                            <td class="text-right text-xss">{{ formatPrice(totalServiceCharge) }}</td>
                            <td class="text-right text-xss">{{ formatPrice(totalRounding) }}</td>
                            <td class="text-right text-xss">{{ formatPrice(totalAmount) }}</td>
                            <td class="text-right text-xss">{{ formatPrice(totalRedemption) }}</td>
                            <td class="text-right text-xss">{{ totalBillCount }}</td>
                            <td class="text-right text-xss">{{ formatPrice(totalBillAvg) }}</td>
                            <td
                              class="text-right text-xss"
                              v-for="(paymentMethod, index) in paymentMethods"
                              :key="'tf-' + index"
                            >{{ formatPrice(totalPaymentMethods[index]) }}</td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between align-items-center mb-3 px-3 pt-3">
                    <div class="rows-per-page">
                      <span class="rows-per-page__label">Rows per page</span>
                      <div class="rows-per-page__control">
                        <select v-model="limit" @change="setLimitPerPage" class="rows-per-page__select">
                          <option :value="20">20</option>
                          <option :value="50">50</option>
                          <option :value="100">100</option>
                        </select>
                      </div>
                    </div>
                    <pagination
                      v-if="pagination.last_page > 1"
                      :pagination="pagination"
                      :current_page="pagination.current_page"
                      :last_page="pagination.last_page"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
    </div>
    <form
      :action="`${actionDownload}/merchant/analytics/collection-by-branch/export`"
      method="POST"
    >
      <input type="hidden" name="merchantId" :value="merchantIdExport" />
      <input type="hidden" name="merchant_code" :value="merchantCode" />
      <input type="hidden" name="token" :value="token" />
      <input type="hidden" name="physical_branch_id" :value="form.physical_branch_id" />
      <!-- <input type="hidden" name="branch_id" :value="form.branch_id" /> -->
      <input type="hidden" name="month" :value="form.month" />
      <input type="hidden" name="from_date" :value="from_date_export" />
      <input type="hidden" name="to_date" :value="to_date_export" />
      <input type="hidden" name="action_export" :value="action_export" />
      <input type="hidden" name="action" value="export" />
      <input id="downloadForm" type="submit" class="d-none" />
    </form>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import "bootstrap/js/dist/modal";
import "@vuepic/vue-datepicker/dist/main.css";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import AnalyticsService from "../../services/analytics.service";
import CommonFunctionService from "../../services/commonFunction.service";
import { startOfMonth } from "date-fns";
import $ from "jquery";
import TokenService from "../../services/token.service";
import FormSearch from "../analytics/components/FormSearch.vue";
import { SEARCH_FIELD } from "./mock_data";
import Pagination from "@/components/Pagination.vue";

export default {
  name: "collection-by-branch-report",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    FormSearch,
    Pagination,
  },
  data() {
    return {
      isLoadDone: false,
      isLoadDoneDataTable: false,
      token: TokenService.getLocalAccessToken(),
      actionDownload: process.env.VUE_APP_BASE_URL,
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCode: localStorage.getItem("MERCHANT_CODE", ""),
      message: "",
      snackbar: null,
      loaderActive: false,
      transactionData: [],
      form: {
        physical_branch_id: 0,
        branch_id: -1,
        month: "",
        from_date: moment(startOfMonth(new Date())),
        to_date: new Date(),
      },
      ESortDirectionSelect: {
        idx: null,
        field: "",
        direction: null,
      },
      ESortDirection: {
        Asc: "asc",
        Desc: "desc",
      },
      paymentMethods: [],
      action_export: "csv",
      from_date_export: "",
      to_date_export: "",
      columnSearch: [],
      searchKeyword: "",
      page: 1,
      limit: 20,
    };
  },
  computed: {
    // The server appends a grand-total as the last element; the visible total
    // now lives in the footer and is recomputed from the filtered rows, so the
    // body renders only the real data rows.
    dataRows() {
      return this.transactionData.length
        ? this.transactionData.slice(0, -1)
        : [];
    },
    headersData() {
      return [
        {
          label: "Branch",
          field: "branch_name",
          hasSortBy: true,
        },
        {
          label: "Sub Total",
          field: "sub_total",
          hasSortBy: true,
        },
        {
          label: "Discount",
          field: "discount",
          hasSortBy: true,
        },
        {
          label: "Gst",
          field: "gst",
          hasSortBy: true,
        },
        {
          label: "Service Charge",
          field: "service_charge",
          hasSortBy: true,
        },
        {
          label: "Rounding",
          field: "rounding",
          hasSortBy: true,
        },
        {
          label: "Total",
          field: "total",
          hasSortBy: true,
        },
        {
          label: "Redemption",
          field: "redemption",
          hasSortBy: true,
        },
        {
          label: "Bill Count",
          field: "bill_count",
          hasSortBy: true,
        },
        {
          label: "Bill AVG",
          field: "bill_avg",
          hasSortBy: true,
        },
      ];
    },
    // Column search boxes + the global "Search:" box, applied over every loaded row
    // (this report loads all matching branches in one request, no server pagination).
    filteredRows() {
      const keyword = (this.searchKeyword || "").trim().toLowerCase();

      return this.dataRows.filter((row) => {
        for (let i = 0; i < this.headersData.length; i++) {
          const term = (this.columnSearch[i + 1] || "").trim().toLowerCase();
          if (!term) continue;
          const field = this.headersData[i].field;
          const cellValue = field ? row?.[field] : "";
          if (!String(cellValue ?? "").toLowerCase().includes(term)) {
            return false;
          }
        }

        for (let i = 0; i < this.paymentMethods.length; i++) {
          const searchIndex = this.headersData.length + i + 1;
          const term = (this.columnSearch[searchIndex] || "").trim().toLowerCase();
          if (!term) continue;
          const amount = row?.payment_methods?.[i]?.amount;
          if (!String(amount ?? "").toLowerCase().includes(term)) {
            return false;
          }
        }

        if (keyword) {
          const values = [
            row?.branch_name,
            row?.sub_total,
            row?.discount,
            row?.gst,
            row?.service_charge,
            row?.rounding,
            row?.total,
            row?.redemption,
            row?.bill_count,
            row?.bill_avg,
            ...(row?.payment_methods || []).map((pm) => pm?.amount),
          ];

          if (!values.some((value) => String(value ?? "").toLowerCase().includes(keyword))) {
            return false;
          }
        }

        return true;
      });
    },
    pagination() {
      const total = this.filteredRows.length;
      const lastPage = Math.max(1, Math.ceil(total / this.limit));
      const currentPage = Math.min(Math.max(1, this.page), lastPage);

      return {
        current_page: currentPage,
        last_page: lastPage,
        total: total,
        prev_page_url: currentPage > 1 ? currentPage - 1 : null,
        next_page_url: currentPage < lastPage ? currentPage + 1 : null,
      };
    },
    paginatedRows() {
      const start = (this.pagination.current_page - 1) * this.limit;
      return this.filteredRows.slice(start, start + this.limit);
    },
    // Footer totals are plain reactive sums over filteredRows (the full filtered result
    // set, not just the current page) so they reset correctly whenever there are no
    // matching rows — unlike a DataTables footerCallback, which writes raw HTML into
    // the footer <td>s and leaves them stale when the table isn't re-drawn.
    totalSubTotal() {
      return this.sumRows("sub_total");
    },
    totalDiscount() {
      return this.sumRows("discount");
    },
    totalGst() {
      return this.sumRows("gst");
    },
    totalServiceCharge() {
      return this.sumRows("service_charge");
    },
    totalRounding() {
      return this.sumRows("rounding");
    },
    totalAmount() {
      return this.sumRows("total");
    },
    totalRedemption() {
      return this.sumRows("redemption");
    },
    totalBillCount() {
      return this.sumRows("bill_count");
    },
    totalBillAvg() {
      return this.totalBillCount > 0 ? this.totalAmount / this.totalBillCount : 0;
    },
    totalPaymentMethods() {
      return this.paymentMethods.map((_, index) =>
        this.filteredRows.reduce(
          (sum, row) => sum + this.parseNum(row?.payment_methods?.[index]?.amount),
          0
        )
      );
    },
  },
  methods: {
    parseNum(value) {
      if (value === null || value === undefined || value === "") return 0;
      const n = parseFloat(String(value).replace(/[^0-9.-]/g, ""));
      return isNaN(n) ? 0 : n;
    },

    sumRows(field) {
      return this.filteredRows.reduce((sum, row) => sum + this.parseNum(row?.[field]), 0);
    },

    format(date) {
      return CommonFunctionService.formatDateShow(date);
    },

    formatPrice(price) {
      price = parseFloat(price).toFixed(2);
      return '$ ' + price.toLocaleString('en-US', {minimumFractionDigits: 2});
    },

    exportFile(type = "csv") {
      this.action_export = type;
      this.from_date_export = this.dateFormat(this.form.from_date);
      this.to_date_export = this.dateFormat(this.form.to_date);
      setTimeout(() => {
        $("#downloadForm").click();
      }, 150);
    },

    dateFormat(date) {
      if (date == null) {
        return null;
      } else {
        return moment(date).format("YYYY-MM-DD");
      }
    },

    onChangeSearchParameter(value, fieldName) {
      this.form[fieldName] = value !== null ? value : (fieldName == SEARCH_FIELD.MONTH ? "" : "-1");
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    // All matching branches are already loaded in one request (this report never has
    // enough rows to need server pagination), so search/sort/paging are all plain
    // reactive Vue state — see filteredRows/pagination/paginatedRows above.
    getList(page) {
      this.page = page;
    },

    onKeywordSearch() {
      this.page = 1;
    },

    setLimitPerPage() {
      this.page = 1;
    },

    searchColumn() {
      this.page = 1;
    },

    handleChangeSortColumn(idx, field, payment_method_idx = 0) {
      if (
        this.ESortDirectionSelect.idx &&
        this.ESortDirectionSelect.idx == idx
      ) {
        this.ESortDirectionSelect.direction =
          this.ESortDirectionSelect.direction === this.ESortDirection.Asc
            ? this.ESortDirection.Desc
            : this.ESortDirection.Asc;
      } else {
        this.ESortDirectionSelect = {
          idx: idx,
          field: field,
          direction: this.ESortDirection.Asc,
        };
      }

      const direction = this.ESortDirectionSelect.direction;
      const totalOrder = this.transactionData.pop();

      this.transactionData.sort(function (item, item2) {
        if (field == "payment_method") {
          if (direction == "asc") {
            if (
              item.payment_methods[payment_method_idx]?.amount >
              item2.payment_methods[payment_method_idx]?.amount
            )
              return 1;
            if (
              item.payment_methods[payment_method_idx]?.amount <
              item2.payment_methods[payment_method_idx]?.amount
            )
              return -1;
          }

          if (direction == "desc") {
            if (
              item.payment_methods[payment_method_idx]?.amount <
              item2.payment_methods[payment_method_idx]?.amount
            )
              return 1;
            if (
              item.payment_methods[payment_method_idx]?.amount >
              item2.payment_methods[payment_method_idx]?.amount
            )
              return -1;
          }

          return 0;
        } else {
          if (direction == "asc") {
            if (item[field] > item2[field]) return 1;
            if (item[field] < item2[field]) return -1;
          }

          if (direction == "desc") {
            if (item[field] < item2[field]) return 1;
            if (item[field] > item2[field]) return -1;
          }

          return 0;
        }
      });

      this.transactionData.push(totalOrder);
      this.page = 1;
    },

    fetchData() {
      this.showLoader();
      var dataForm = {
        physical_branch_id: this.form.physical_branch_id,
        // branch_id: this.form.branch_id,
        month: this.form.month,
        from_date: this.dateFormat(this.form.from_date),
        to_date: this.dateFormat(this.form.to_date),
      };

      AnalyticsService.collectionByBranchReport(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.transactionData = response.data.data.daily_collections;
            this.paymentMethods = response.data.data.payment_methods;
            const totalColumn =
              this.headersData.length + this.paymentMethods.length;
            this.columnSearch = [""];

            for (let i = 0; i < totalColumn; i++) {
              this.columnSearch.push("");
            }

            this.searchKeyword = "";
            this.page = 1;
            this.isLoadDone = true;
            this.isLoadDoneDataTable = true;
            this.hideLoader();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
            this.hideLoader();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },
  },
};
</script>
<style scoped>
table thead th:not(:first-child) {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

table thead th > span {
  position: relative;
}

input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
}

input[type="search"]::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
}

input[type="search"]:focus {
  border-color: #72959d;
  outline: none;
  border: none;
  border-bottom: 2px solid #72959d;
}

.nosubmit-parent {
  border: none;
  padding: 0;
}

input.nosubmit {
  border-bottom: 1px solid #d2d2d2;
  width: 100%;
  padding: 9px 4px 9px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

.date-time-dashboad .dp__input_wrap {
  min-width: 200px !important;
  width: 250px;
}

.custom-control-label label {
  padding-top: 14px !important;
}

.pt-custtom {
  padding-top: 7px;
}

tbody:not(.no-data) > tr:nth-child(2n + 1) {
  background: #f0f2f5;
}

tbody:not(.no-data) > tr:hover {
  background: #ebecee;
}

tr.total-row {
  font-weight: bold;
  color: #222;
}

.custom-table :not(caption) > * > * {
  border-right-width: 1px !important;
}

.custom-table :not(caption) > * > *:first-child {
  border-left-width: 1px !important;
}

/* Fit the section within the viewport (minus the title bar) so the page itself
   doesn't scroll — the table region handles its own scrolling instead */
.page-header.my-transacions {
  min-height: calc(100vh - 70px) !important;
}

/* Scroll only the table region so the page stays put; cap height to the viewport */
.custom-table :deep(.dt-layout-table > .dt-layout-cell) {
  max-height: calc(100vh - 360px);
  overflow: auto;
}

/* Separate borders so the grid lines travel with the sticky header/total row */
.custom-table table.dataTable {
  border-collapse: separate;
  border-spacing: 0;
}

.custom-table table.dataTable th,
.custom-table table.dataTable td {
  border-right: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
}

.custom-table table.dataTable th:first-child,
.custom-table table.dataTable td:first-child {
  border-left: 1px solid #dee2e6;
}

.custom-table table.dataTable thead tr:first-child th {
  border-top: 1px solid #dee2e6;
}

/* Keep the header (both rows) fixed at the top while scrolling */
.custom-table table.dataTable thead {
  position: sticky;
  top: 0;
  z-index: 3;
}

.custom-table table.dataTable thead th {
  background: #fff;
}

/* Keep the total row fixed at the bottom */
.custom-table table.dataTable tfoot tr.total-row td {
  position: sticky;
  bottom: 0;
  z-index: 2;
  background: #e9edf2;
  border-top: 1px solid #dee2e6;
}
/* Empty-state ("No matching records found") cell: keep the same left/right
   grid borders as the data rows (the width-only rules do not render on a
   single colspan cell). */
.custom-table tbody.no-data > tr > td {
  border-left: 1px solid #dee2e6 !important;
  border-right: 1px solid #dee2e6 !important;
}

/* Column search inputs, styled like POS Daily Collection */
.custom-table table.dataTable thead th input {
  width: 100%;
  box-sizing: border-box;
  padding: 5px 8px;
  border: 1px solid #d2d6da;
  font-size: 13px;
  color: #495057;
  font-weight: normal;
}

.custom-table table.dataTable thead th input:focus {
  outline: none;
  border-color: #72959d;
  box-shadow: 0 0 0 2px rgba(114, 149, 157, 0.15);
}

/* Global "Search:" box */
.global-search {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.global-search input {
  padding: 6px 12px;
  border: 1px solid #d2d6da;
  font-size: 13px;
  font-weight: normal;
  color: #495057;
  background: #fff;
  min-width: 220px;
}

.global-search input:focus {
  outline: none;
  border: 1px solid #72959d;
  box-shadow: 0 0 0 2px rgba(114, 149, 157, 0.15);
}

</style>
